import React from 'react';
import { Helmet } from 'react-helmet';
import { ReactComponent as CalendarIcon } from '../../assets/svg/calendar-icon.svg';
import './MyTips.scss';
import { FcDocument } from 'react-icons/fc';
import analyticsWrapper from '../../utils/analyticsWrapper';

function CalendarBox() {
  return (
    <div className="calendarBox">
      <div className="header">
        Automated invoice reminders in Google Calendar
      </div>
      <button
        type="button"
        id="go-to-invoice-calendar"
        className="connect-Calendar-btn"
        onClick={() => {
          analyticsWrapper.event({
            category: 'courier-invoice',
            action: `go-to-invoice-calendar button click`,
            label: 'click',
          });
          window.open(
            `https://calendar.google.com/calendar?cid=cG9ydGVyYnVkZHkuY29tX244MmVrYzMzNjk1bmRuM2ljNWQ1c2tpZXNvQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20
            `,
            '_blank'
          );
        }}
      >
        <CalendarIcon className="logoInButton" />
        <span className="textInButton">
          Get invoice reminders with Google calendar
        </span>
      </button>
      <span className="textUnderBtn">
        Click on the button to connect with your Google calendar
      </span>
    </div>
  );
}

function LinkToBox() {
  return (
    <div className="calendarBox">
      <div className="header"> Google Doc of how to send invoice correctly</div>
      <button
        type="button"
        id="go-to-invoice-doc"
        className="connect-Calendar-btn"
        onClick={() => {
          analyticsWrapper.event({
            category: 'courier-invoice',
            action: `go-to-invoice-doc button click`,
            label: 'click',
          });
          window.open(
            `https://docs.google.com/document/d/15K1MfjHoGTV1-jIHx77X3-V9jalsNcGoYCAio5jm8ng/edit?usp=sharing
            `,
            '_blank'
          );
        }}
      >
        <FcDocument className="logoInButton" />

        <span className="textInButton">Go to Google doc</span>
      </button>
      <span className="textUnderBtn">
        Click on the button to see how to send invoice
      </span>
    </div>
  );
}
export function MyTips(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>My tips</title>
      </Helmet>
      <div className="helpPage">
        <div className="conetentBox">
          <div className="title-header">{'Invoice tips and tricks'}</div>
          <CalendarBox />
          <LinkToBox />
        </div>
      </div>
    </>
  );
}
